<template>
  <b-list-group-item>
    <slot name="extra" :result="result"></slot>
    <template v-if="result.gender != null">
      <font-awesome-icon
        v-if="result.gender"
        class="mr-1"
        icon="male"
      ></font-awesome-icon>
      <font-awesome-icon v-else class="mr-1" icon="female"></font-awesome-icon>
    </template>
    <div>
      {{ result.first_name }} {{ result.last_name }}
      <span v-if="result.nickname">({{ result.nickname }})</span>
    </div>
    <div>
      <b-badge>
        {{ result.position == 0 ? "Student" : "Teacher/Parent" }}
      </b-badge>
    </div>
    <div v-if="result.email">
      <a :href="`mailto:${result.email}`" class="text-muted">{{
        result.email
      }}</a>
    </div>
  </b-list-group-item>
</template>
<script lang="js">

export default {
    name: 'search-people-result',
    props: ["result"]
}
</script>
